import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ children, classes, icon, route, ...props }) => {
	return (
		<Link to={route} {...props} className={`${classes && classes} btn fw-semibold`}>
			{icon && <i className={`${icon} me-2`}></i>}
			{children}
		</Link>
	);
};

export default Button;
